

import { Mixins, Component, Prop } from "vue-property-decorator";
import {
    HomeRow
} from "@/view-models";
import SetAsFavoriteMixin from "./SetAsFavoriteMixin";
import { namespace } from 'vuex-class';
const app = namespace("app");

@Component
export default class Row extends Mixins(SetAsFavoriteMixin) {
    @Prop() value!: HomeRow
    @Prop({ default: () => 12 }) colSize?: number
    @Prop({ required: true }) bg?: string

    @app.State
    public lang!: string

    async goToDetail(itemId: string){
      await this.$router.push({ name: 'HomeDetailResult', params: { id: itemId } });
      this.$root.$emit("detailResult", this.value);
    }
}

